import { configureStore } from '@reduxjs/toolkit';
import appReducer from './appSlice/appSlice';
import userReducer from './userSlice/userSlice';
import shopReducer from './shopSlice/shopSlice';
import storiesReducer from './storiesSlice/storiesSlice';
import dashboardReducer from './dashboardSlice/dashboardSlice';
import metricReducer from './metricSlice/metricSlice';
import welcomeReducer from './welcomeSlice/welcomeSlice';

export const store = configureStore({
  reducer: {
    app: appReducer,
    user: userReducer,
    shop: shopReducer,
    stories: storiesReducer,
    dashboard: dashboardReducer,
    metric: metricReducer,
    welcome: welcomeReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
